<template>
  <v-container>
    <h2></h2>
    <v-row>
      <v-col lg="10" md="12" xs="12">
        <app-personal
          :customer="customer"
        />
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'customer-list' }"
          >
            Back
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "CustomerView",
  components: {
    AppPersonal: () => import('../components/personal.view'),
  },
  data: () => ({
    customer_id: null,
    customer: {
      firstname: null,
      lastname: null,
      display_name: null,
      email: null,
      phone_number: null,
      line_id: null,
      facebook_name: null
    },
  }),
  async mounted () {
    let id = this.$route.params.id
    await this.getCustomer(id)
  },
  methods: {
    async getCustomer (id) {
      this.customer_id = id
      try {
        const result = await this.$http.get(`/back-office/customers/${this.customer_id}`, authHeader())
        this.customer.firstname = result.data.firstname
        this.customer.lastname = result.data.lastname
        this.customer.display_name = result.data.display_name
        this.customer.email = result.data.email
        this.customer.phone_number = result.data.phone_number
        this.customer.line_id = result.data.line_id
        this.customer.facebook_name = result.data.facebook_name
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    requireField () {
      return true
    }
  },
};
</script>
